var React = require('react');

function SortDefaultIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","fill":"white","key":0}),React.createElement("path",{"d":"M8 6.5V2M8 2L5 5M8 2L11 5","stroke":"#00121A","strokeOpacity":"0.38","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 9.5V14M8 14L5 11M8 14L11 11","stroke":"#00121A","strokeOpacity":"0.38","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

SortDefaultIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SortDefaultIcon;

SortDefaultIcon.default = SortDefaultIcon;
